  /* sitelock */
  const sitelockTrue = () => {
    const elementToHide = document.querySelector('.section-fall-winter-sitelock');
    if (elementToHide) {
      elementToHide.style.display = 'none';
    }

    const heroToHide = document.querySelector('.normal_site');
    if (heroToHide) {
      heroToHide.style.display = 'none';
    }

    const heroToShow = document.querySelector('.sl_display_none');
    if (heroToShow) {
      heroToShow.style.display = 'block';
    }

    const elementToDisplay = document.querySelector('.lcdk_main_section');
    if (elementToDisplay) {
      elementToDisplay.style.display = 'block';
    }

  }

  const sitelockFalse = () => {
    const hideElement = document.querySelector('.sl_display_none');
    if (hideElement) {
      hideElement.style.display = 'none';
    }

    const hideElement2 = document.querySelector('.lcdk_main_section');
    if (hideElement2) {
      hideElement2.style.display = 'none';
    }
  }

  export const initSitelock = ( hasSitelockClass) => {

    if (hasSitelockClass) {
      sitelockTrue();
    } else {
      sitelockFalse();
    }

  };


  //  sitelock message when new email signup
  let queryString = window.location.search;
  let message = document.getElementById('ss24-message');

  if (queryString.includes('contact')) {
    message.style.display = 'block';
  }
